module.exports = __webpack_public_path__ + "static/media/post-card-screenshot.eb02306c.png";